import { AxiosRequestConfig } from 'axios';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { Alert, AlertClose, ApiError, IParentModal, SiteMessageRequest } from '@types';
import { config } from '../../config';

export const fetchAlertAsync = createAsyncAction(
    [
        'alert/FETCH_ALERT_REQUEST',
        (request: SiteMessageRequest) => {
            return {
                url: `${config.env('awsUrl')}/api/v1/selfserv/customers/notifications/site-messages`,
                data: request,
                headers: { 'Content-Type': 'application/json' },
                method: 'post'
            } as AxiosRequestConfig;
        }
    ],
    ['alert/FETCH_ALERT_SUCCESS', (response: Alert) => response],
    ['alert/FETCH_ALERT_FAILURE', (error: ApiError) => error],
    'alert/FETCH_ALERT_CANCEL'
)();
export const closeAlertAction = createAction('alert/CLOSE_REQUEST', (alert: boolean, notificationId: string) => ({
    alert,
    notificationId
}))<AlertClose>();
